import { combineReducers } from '@ngrx/store';
import { AuthStateInterface } from './auth.state';
import { RolesReducer } from './roles/roles.reducer';
import { UserReducer } from './user/user.reducer';

export const reducers = combineReducers<AuthStateInterface>({
  roles: RolesReducer,
  user: UserReducer,
});
